module.exports = __webpack_public_path__ + "static/media/order-user-bg.ad89e036.png";